import { AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';

export function phaseStartLessThanPhaseEndValidator(phaseEndControl: AbstractControl): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const phaseStart = control.value;
    const phaseEnd = phaseEndControl.value;

    if ((phaseStart === null || phaseStart === '') && (phaseEnd === null || phaseEnd === ''))
      return null;

    if ((phaseStart && !phaseEnd) || (!phaseStart && phaseEnd)) {
      return { rangeNotCompleted: true };
    }

    if (phaseStart > phaseEnd) {
      return { rangeInvalid: true };
    }

    return null;
  };
}

export const rangeValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const min = control.get('min')?.value;
  const max = control.get('max')?.value;

  if ((min === null || min === '') && (max === null || max === '')) {
    return null;
  }

  if ((min && !max) || (!min && max)) {
    return { rangeNotCompleted: true };
  }

  if (min > max) {
    return { rangeInvalid: true };
  }

  return null;
};
